// Load all the controllers within this directory and all subdirectories. 
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import StimulusReflex from 'stimulus_reflex'
import consumer from '../channels/consumer'
import controller from './application_controller'
import ContentLoader from 'stimulus-content-loader'
import Remote from 'stimulus-remote-rails'
import Clipboard from 'stimulus-clipboard'
import TextareaAutogrow from 'stimulus-textarea-autogrow'
import Notification from 'stimulus-notification'
import { Autocomplete } from "stimulus-autocomplete";
//import controller_v2 from './application-v2_controller'
import NestedForm from "stimulus-rails-nested-form"

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)
application.load(definitionsFromContext(context))
application.register("nested-form", NestedForm)
application.register('clipboard', Clipboard)
application.register('content-loader', ContentLoader)
application.register('remote', Remote)
application.register('textarea-autogrow', TextareaAutogrow)
application.register('notification', Notification)
application.register("autocomplete", Autocomplete);


StimulusReflex.initialize(application, { consumer, controller, isolate: true })
//StimulusReflex.initialize(application, { consumer, controller_v2, isolate: true })
